import { authRoles } from '../../../auth/authRoles'
import KardexPeriodoGestion from './view/KardexPeriodoGestion'

export const kardexPeriodoRoutesMap = {
  gestion: {
    path: '/kardexPeriodo/gestion',
    name: 'Inicio operaciones',
    action: 'INICIO_OPERACIONES',
  },
  registro: {
    path: '/kardexPeriodo/nuevo',
    name: 'Nuevo kardex período',
    action: 'NUEVO_KARDEX_PERIODO',
  },
}

const kardexPeriodoRoutes = [
  {
    path: kardexPeriodoRoutesMap.gestion.path,
    element: <KardexPeriodoGestion />,
    auth: authRoles.admin,
  },
]
export default kardexPeriodoRoutes
